import movimentosApi from "@/app/services/movimentoestoque";
import produtosApi from "@/app/services/produtos";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    movimento: {
      fornecedor_id: "",
      loja_id_destino: "",
      pedidocompra_id: null,
      data: "",
      movimento: "Entrada",
      itens: 0,
      quantidade_total: 0,
      valor_total: 0,
      observacoes: "",
      produtos: [],
      contaspagar: [],
    },
    movimentos: [],
    produtos: [],
    pagination: PAGINATION_OPTIONS,
    total_de_registros: 0,
    search: "",
  },

  mutations: {
    listar(state, movimentos) {
      state.movimentos = movimentos;
    },

    abrir(state, movimento) {
      state.movimento = movimento;
    },

    salvar(state, movimento) {
      state.movimentos.push(movimento);
    },

    atualizar(state, movimento) {
      let index = state.movimentos.findIndex(
        (movimento_) => movimento_.id == movimento.id
      );
      if (index > -1) {
        state.movimentos.splice(index, 1, movimento);
      }
    },

    excluir(state, id) {
      let index = state.movimentos.findIndex((movimento) => movimento.id == id);
      if (index > -1) {
        state.movimentos.splice(index, 1);
      }
    },

    UNSET_MOVIMENTO(state) {
      state.movimento = {
        fornecedor_id: "",
        loja_id_destino: "",
        pedidocompra_id: null,
        data: "",
        movimento: "Entrada",
        itens: 0,
        quantidade_total: 0,
        valor_total: 0,
        observacoes: "",
        produtos: [],
        contaspagar: [],
      };
    },

    set_listagem(state, listagem) {
      state.pagination.listagem = listagem;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },
  },

  actions: {
    async listar({ commit, state }) {
      // if (state.movimentos.length == 0) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await movimentosApi.listar(parametros);
      commit("listar", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });

      // }
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let movimento = await movimentosApi.abrir(id);
      commit("abrir", movimento);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit }, movimento) {
      let novo = await movimentosApi.salvar(movimento);
      // commit('salvar', novo);
    },

    async atualizar({ commit }, movimento) {
      let movimento_salvo = await movimentosApi.atualizar(movimento);
      // delete movimento_salvo.submovimentoestoque;
      commit("atualizar", movimento_salvo);
    },

    async transferir({}, movimento) {
      await movimentosApi.transferir(movimento);
    },

    async excluir({ commit }, id) {
      await movimentosApi.excluir(id);
      commit("excluir", id);
    },

    buscarProdutoPorReferencia({ commit }, referencia) {
      return produtosApi.buscarProdutoPorReferencia(referencia);
    },
  },
};
